export enum TimeSlotTypeEnum {
  Pickup = 'pickup',
  Delivery = 'delivery',
}